import React, { useEffect, Fragment, useState } from 'react';

import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from 'recharts';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import MainContainer from '../components/MainContainer';
import ResultDescription from '../components/ResultDescription';
import { getUserDetails } from '../actions/userActions';

import exploraLogoDark from '../assets/images/explora-logos_black.png';

const ResultsScreen = ({ history }) => {
  const dispatch = useDispatch();
  const [graphData, setGraphData] = useState([{ category: '', points: 0 }]);
  const { loading, error, answer } = useSelector((state) => state.userAnswer);
  const { loadingUser, userInfo, success } = useSelector((state) => state.user);

  useEffect(() => {
    if (!loading) {
      if (!answer || !answer.completed) {
        history.push('/dashboard');
      } else {
        const tempData = answer.result.map((r) => {
          return { category: r.name, points: r.points };
        });
        setGraphData(tempData);
      }
    }
  }, [answer.completed, loading, history, setGraphData, answer]);

  useEffect(() => {
    if (!loadingUser && !userInfo) {
      history.push('/login');
    } else {
      dispatch(getUserDetails('profile'));
    }
  }, [dispatch, history, userInfo, success, loadingUser]);

  const getHeader = () => (
    <>
      <Row className='d-print-none'>
        <Col className='text-left p-2' xs={12} md={6}>
          <strong>Nome:</strong>
          <br />
          {userInfo?.name}
        </Col>
        <Col className='text-left p-2' xs={12} md={6}>
          <strong>Email:</strong>
          <br />
          {userInfo?.email}
        </Col>
      </Row>

      <Row className='d-none d-print-flex'>
        <Col className='text-left p-2' xs={4}>
          <strong>Nome:</strong>
          <br />
          {userInfo?.name}
        </Col>
        <Col className='text-left p-2' xs={4}>
          <strong>Email:</strong>
          <br />
          {userInfo?.email}
        </Col>
      </Row>
    </>
  );

  return (
    <MainContainer header={getHeader()}>
      <Row>
        <Col xs={9}>
          <h4
            className='text-secondary'
            style={{ marginBottom: '0', paddingBottom: '0' }}
          >
            Gráfico de Análise de perfil
          </h4>
          <p className='text-secondary mb-4'>
            A seguir você poderá analisar o resultado de suas respostas.
          </p>
        </Col>
        <Col xs={3}>
          <img
            src={exploraLogoDark}
            style={{ maxWidth: '100px' }}
            className='float-right d-none d-print-flex'
            alt='explora logo'
          />
        </Col>
      </Row>
      {error && <Message variant='danger'>{error}</Message>}
      {loading ? (
        !error && <Loader />
      ) : (
        <Fragment>
          <Row style={{ minHeight: '350px' }} align='center'>
            <Col>
              <ResponsiveContainer>
                <RadarChart data={graphData}>
                  <PolarGrid />
                  <PolarAngleAxis dataKey='category' />
                  <PolarRadiusAxis />
                  <Radar
                    dataKey='points'
                    stroke='#e95420'
                    fill='#e95420'
                    fillOpacity={0.5}
                  />
                </RadarChart>
              </ResponsiveContainer>
            </Col>
          </Row>
          <Row>
            <Col>{<ResultDescription result={graphData} />}</Col>
          </Row>
        </Fragment>
      )}
    </MainContainer>
  );
};

export default ResultsScreen;
